<div class="actions-container">
    <app-button class="btn-cta-dropdown" [disabled]="isDisabled" (click)="menu.toggle($event)">
        @if (isLoading) {
            <app-spinner class="btn-spinner" />
        }
        {{ 'Actions' | localize }}
        <app-svg-icon icon="arrow-down-cta"/>
    </app-button>

    <p-menu #menu [model]="menuItems" [popup]="true" styleClass="btn-cta-dropdown-menu">
        <ng-template pTemplate="item" let-item>
            @if (showItem(item)) {
                <a class="btn-cta-dropdown-menu-item" (click)="item.onClick()">
                    @if (item.icon) {
                        <app-svg-icon [icon]="item.icon" class="item-icon"/>
                    }
                    <span>{{ item.text }}</span>
                </a>
            }
        </ng-template>
    </p-menu>
</div>
